module.exports = __webpack_public_path__ + "img/thumbnail_ProboscisMonkey_m_normal.c3c3bcdc.png";